import { useFormContext, useWatch } from "react-hook-form";

import { AggregatedCustomInput } from "#modules/quoteRequestLines/domain/aggregateCustomInputs";
import { QuoteRequestLineFormData } from "#modules/quoteRequestLines/types/QuoteRequestLineFormData";
import { Group } from "#shared/view/components/Group";

import { INPUT_WIDTH } from "./constants";
import { CustomInputController } from "./CustomInputController";

type Props = {
  customInput: AggregatedCustomInput;
  quoteRequestLineId: string | undefined;
  isPredicting: boolean;
};

export const CustomInputRow = ({ customInput, quoteRequestLineId, isPredicting }: Props) => {
  const { getValues, control, setValue } = useFormContext<QuoteRequestLineFormData>();
  const formCustomInputs = getValues("customInputs");

  const mainInputIndex = formCustomInputs.findIndex(
    (formInput) => formInput.key === customInput.key,
  );

  const relativeInputIndex = customInput.relativeInput
    ? formCustomInputs.findIndex((formInput) => formInput.key === customInput.relativeInput?.key)
    : -1;

  const mainInputValue = useWatch({
    control,
    name: `customInputs.${mainInputIndex}.value` as const,
  });
  const isMainInputDefault =
    mainInputValue === customInput.defaultValue ||
    (mainInputValue === null && customInput.defaultValue === null) ||
    (mainInputValue === "" && !customInput.defaultValue);

  const currentRelativeValue = useWatch({
    control,
    name: `customInputs.${relativeInputIndex}.value` as const,
  });

  if (isMainInputDefault && customInput.relativeInput && relativeInputIndex !== -1) {
    if (currentRelativeValue !== "100") {
      setValue(`customInputs.${relativeInputIndex}.value`, "100");
    }
  }

  return (
    <Group>
      <CustomInputController
        customInput={customInput}
        index={mainInputIndex}
        quoteRequestLineId={quoteRequestLineId}
        maw={INPUT_WIDTH}
        disabled={isPredicting}
      />
      {customInput.relativeInput && relativeInputIndex !== -1 && (
        <CustomInputController
          customInput={customInput.relativeInput}
          index={relativeInputIndex}
          quoteRequestLineId={quoteRequestLineId}
          maw={INPUT_WIDTH}
          disabled={isPredicting || isMainInputDefault}
        />
      )}
    </Group>
  );
};
